export default __webpack_public_path__ + "static/media/NotFound-dark.438f54b5.svg";